import { css } from 'styled-components';
import { colors, breakpoints } from '../../style-utilities/variables';
export default css`
  .contact-time {
    margin-bottom: 5px;
  }
  background: #e0e0e0;
  color: ${colors.primary};
`;
